// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { InvoiceDataFragment } from '../../fragments/generated/invoice-data.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetInvoiceDataFromInvoiceIdQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['Int']['input'];
}>;


export type GetInvoiceDataFromInvoiceIdQueryResult = { __typename?: 'Query', getInvoiceDataFromInvoiceId: { __typename?: 'InvoiceDataDTO', eInvoiceSendTimestamp: LocalDateTime | null, eInvoiceStatus: Types.EInvoiceStatusEnumDto | null, bolloAmount: number | null, cashRegisterClosure: string | null, cashRegisterCode: string | null, cashRegisterNumber: string | null, cashRegisterPrintTimestamp: LocalDateTime | null, cigCode: string | null, codiceCommessaConvenzione: string | null, cupCode: string | null, dataDocumento: LocalDate | null, externalCode: string | null, id: number, idDocumento: string | null, invoiceId: number, relatedDocumentType: Types.RelatedDocumentTypeDto | null, vatChargeability: string | null } | null };

export const GetInvoiceDataFromInvoiceIdGql = gql`
    query GetInvoiceDataFromInvoiceId($invoiceId: Int!) {
  getInvoiceDataFromInvoiceId(invoiceId: $invoiceId) {
    ...InvoiceData
  }
}
    ${InvoiceDataFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvoiceDataFromInvoiceIdInjectable extends Apollo.Query<GetInvoiceDataFromInvoiceIdQueryResult, GetInvoiceDataFromInvoiceIdQueryVariables> {
    override document = GetInvoiceDataFromInvoiceIdGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */